
import { useClienteContext } from '../../../contexts/ClienteContext';
import { useEmpresaContext } from '../../../contexts/EmpresaContext';
import { generarPdfDetalleStockVentaAnticipada } from '../../../services/generarPdfDetalleStockVentaAnticipada';
import { Printer, X } from 'lucide-react';

const COLUMNAS = [
    { label: 'Fecha', align: 'text-center' },
    { label: 'Comentario', align: 'text-left' },
    { label: 'Comprobante', align: 'text-center' },
    { label: 'E/S', align: 'text-center' },
    { label: 'Entrada', align: 'text-right' },
    { label: 'Salida', align: 'text-right' },
    { label: 'Saldo', align: 'text-right' },
];

export default function DetalleStockVentaAnticipada({ detalleMovStock, onClose, movStockVtaAnticipada }) {
    const { getCliente } = useClienteContext();
    const data = getCliente();
    const { getEmpresa } = useEmpresaContext();
    const empresa = getEmpresa();

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

            <div className="relative z-10 w-full max-w-5xl bg-gray-900 border border-white/8 rounded-2xl overflow-hidden shadow-2xl flex flex-col max-h-[50vh]"
                onClick={e => e.stopPropagation()}>

                {/* HEADER */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-white/5 flex-shrink-0">
                    <div>
                        <div className="text-[#c9a84c] text-[9px] font-black uppercase tracking-[0.6em] mb-1">
                            Detalle de artículo
                        </div>
                        <p className="text-white font-black text-sm tracking-wide">
                            {movStockVtaAnticipada?.Codarticulo}
                            <span className="text-white/40 font-normal ml-2 text-xs">{movStockVtaAnticipada?.Descarticulo}</span>
                        </p>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => generarPdfDetalleStockVentaAnticipada(detalleMovStock, data, empresa)}
                            disabled={!detalleMovStock?.length}
                            className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center text-[#c9a84c]/50 hover:text-[#c9a84c] hover:border-[#c9a84c]/30 transition-all disabled:opacity-20 disabled:cursor-not-allowed">
                            <Printer size={14} />
                        </button>
                        <button onClick={onClose}
                            className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center text-white/30 hover:text-white hover:border-white/30 transition-all">
                            <X size={14} />
                        </button>
                    </div>
                </div>

                {/* TABLA */}
                <div className="overflow-auto flex-1">
                    <table className="w-full border-collapse text-xs">
                        <thead>
                            <tr className="bg-gray-800 sticky top-0 z-10">
                                {COLUMNAS.map((col, i) => (
                                    <th key={i}
                                        className={`px-3 py-2 border-r border-gray-700 text-white/70 font-bold uppercase tracking-wider whitespace-nowrap last:border-r-0 ${col.align}`}>
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {detalleMovStock?.length > 0 ? (
                                (() => {
                                    let saldo = 0;
                                    return detalleMovStock.map((detalle, index) => {
                                        if (detalle?.Entsal === 'E') saldo += detalle?.Entrada;
                                        else if (detalle?.Entsal === 'S') saldo -= detalle?.Salida;
                                        return (
                                            <tr key={index} className="bg-white/[0.02] hover:bg-white/[0.05] border-b border-white/5 transition-colors">
                                                <td className="px-3 py-1.5 border-r border-white/5 text-gray-400 text-center font-mono">{detalle?.Fecha}</td>
                                                <td className="px-3 py-1.5 border-r border-white/5 text-white/80 text-left max-w-[200px] truncate">{detalle?.Comentario}</td>
                                                <td className="px-3 py-1.5 border-r border-white/5 text-gray-400 text-center font-mono">{detalle?.Nrocomprobante}</td>
                                                <td className="px-3 py-1.5 border-r border-white/5 text-center">
                                                    <span className={`font-black text-[10px] ${detalle?.Entsal === 'E' ? 'text-green-400' : 'text-red-400'}`}>
                                                        {detalle?.Entsal}
                                                    </span>
                                                </td>
                                                <td className="px-3 py-1.5 border-r border-white/5 text-green-400 font-mono text-right">
                                                    {detalle?.Entsal === 'E' ? detalle?.Entrada.toFixed(3) : ''}
                                                </td>
                                                <td className="px-3 py-1.5 border-r border-white/5 text-red-400 font-mono text-right">
                                                    {detalle?.Entsal === 'S' ? detalle?.Salida.toFixed(3) : ''}
                                                </td>
                                                <td className="px-3 py-1.5 text-white font-black font-mono text-right">
                                                    {saldo.toFixed(3)}
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-white/20 font-bold text-xs text-center py-8 uppercase tracking-widest">
                                        Sin movimientos
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* FOOTER TOTALES */}
                <div className="flex-shrink-0 px-6 py-3 border-t border-white/5 flex items-center justify-between">
                    <button onClick={onClose}
                        className="flex items-center gap-2 px-6 py-2 border border-white/10 hover:border-red-500/30 hover:bg-red-500/5 text-white/30 hover:text-red-400 text-[10px] font-black uppercase tracking-widest rounded-xl transition-all duration-300">
                        <X size={12} />
                        Cerrar
                    </button>

                    <div className="flex items-center gap-4">
                        <div className="text-center">
                            <div className="text-white/20 text-[8px] font-black uppercase tracking-widest">Entradas</div>
                            <div className="text-green-400 font-black font-mono text-sm">{movStockVtaAnticipada?.Entrada.toFixed(3)}</div>
                        </div>
                        <div className="w-px h-8 bg-white/5" />
                        <div className="text-center">
                            <div className="text-white/20 text-[8px] font-black uppercase tracking-widest">Salidas</div>
                            <div className="text-red-400 font-black font-mono text-sm">{movStockVtaAnticipada?.Salida.toFixed(3)}</div>
                        </div>
                        <div className="w-px h-8 bg-white/5" />
                        <div className="text-center px-4 py-1.5 border border-[#c9a84c]/20 rounded-xl bg-[#c9a84c]/5">
                            <div className="text-[#c9a84c]/50 text-[8px] font-black uppercase tracking-widest">Saldo</div>
                            <div className="text-white font-black font-mono text-sm">{movStockVtaAnticipada?.Saldo.toFixed(3)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}